// TODO: Clean up how steps are handled. Right now "stepNeedsAttention"
// does basically nothing. We'll want to use "step" to store any
// step-specific state.
const initialState = {
  user: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    address: "",
    unitNumber: "",
    city: "",
    state: "",
    zip: "",
    ssn: "", // < Might want to store as string, to use .length without having to .toString
    dob: "",
    termsAccepted: false,
    ppAccepted: false,
    finicityCustomerId: null
  },
  basicInfo: {
    stepIsComplete: false,
    stepNeedsAttention: false
  },
  personalInformation: {
    stepIsComplete: false,
    stepNeedsAttention: false
  },
  address: {
    stepIsComplete: false,
    stepNeedsAttention: false
  },
  verifyPhone: {
    stepIsComplete: false,
    stepNeedsAttention: false
  },
  verifyIdentity: {
    stepIsComplete: false,
    stepNeedsAttention: false
  },
  processingId: {
    stepIsComplete: false,
    stepNeedsAttention: false
  },
  processingApplication: {
    stepIsComplete: false,
    stepNeedsAttention: false
  },
  linkBank: {
    stepIsComplete: false,
    stepNeedsAttention: false,
    accountErrors: []
  },
  student: {
    stepIsComplete: false
  },
  editOnboardingUserInfo: {
    stepIsComplete: false,
    stepNeedsAttention: false
  },
  verifyIdDocs: {
    stepIsComplete: false,
    stepNeedsAttention: false
  },
  decision: {
    approved: null,
    amount: null,
    reason: null
  },
  addressValid: false,
  ssnValid: false,
  idFront: null,
  idBack: null,
  idValid: null,
  idNeedsReview: null,
  identityVerified: null, // ID and Identity are different things!
  emailVerified: false,
  phoneVerificationSent: false,
  phoneVerificationError: null,
  phoneVerified: null,
  networkingError: null,
  fingerprint: null,
  refreshToken: null,
  plaidLinkToken: null,
  plaidAccessToken: null,
  balance: null,
  income: null,
  applicationProgress: {},
  verificationProgress: {
    percentage: 0,
    duration: 0,
    time: 0
  },
  loginsRequired: null,
  showIdTips: true
};

export default function register(state = initialState, action) {
  switch (action.type) {
    case "UPDATE_USER":
      return { ...state, user: { ...state.user, ...action.payload } };
    case "UPDATE_VERIFICATION_PROGRESS":
      return {
        ...state,
        verificationProgress: {
          ...state.verificationProgress,
          ...action.payload
        }
      };
    case "VERIFICATION_EMAIL_VALID":
      return { ...state, emailVerified: action.payload };
    case "VERIFICATION_SMS_SENT":
      return {
        ...state,
        phoneVerificationSent: action.sent,
        smsSendError: null
      };
    case "VERIFICATION_SMS_CHECK_ERROR":
      return { ...state, phoneVerificationError: action.error };
    case "VERIFICATION_SMS_VALID":
      return {
        ...state,
        verifyPhone: { ...state.verifyPhone, stepIsComplete: true },
        phoneVerified: action.valid,
        phoneVerificationError: null
      };
    case "VERIFICATION_SMS_RESET":
      return {
        ...state,
        verifyPhone: { ...state.verifyPhone, stepIsComplete: false },
        phoneVerified: null,
        phoneVerificationSent: false,
        phoneVerificationError: null
      };
    case "UPDATE_STEP":
      return {
        ...state,
        [action.stepName]: {
          ...state[action.stepName],
          ...action.payload
        }
      };
    case "SET_FINGERPRINT":
      return {
        ...state,
        fingerprint: action.fingerprint
      };
    case "SET_REFRESH_TOKEN":
      return {
        ...state,
        refreshToken: action.refreshToken
      };
    case "SET_PLAID_LINK_TOKEN":
      return {
        ...state,
        plaidLinkToken: action.plaidLinkToken
      };
    case "SET_PLAID_ACCESS_TOKEN":
      return {
        ...state,
        plaidAccessToken: action.plaidAccessToken
      };
    case "VERIFICATION_SMS_SEND_ERROR":
      return {
        ...state,
        smsSendError: action.error
      };
    case "UPDATE_USER_BALANCE":
      return {
        ...state,
        balance: action.balance
      };
    case "UPDATE_USER_INCOME":
      return {
        ...state,
        income: action.income
      };
    case "SET_ID_FRONT":
      return {
        ...state,
        idFront: action.idFront
      };
    case "SET_ID_BACK":
      return {
        ...state,
        idBack: action.idBack
      };
    case "SET_IDENTITY_VERIFIED":
      return {
        ...state,
        identityVerified: action.verified
      };
    case "ID_VALID":
      return {
        ...state,
        idValid: action.valid
      };
    case "SHOW_ID_TIPS":
      return {
        ...state,
        showIdTips: action.show
      };
    case "SET_ID_NEEDS_REVIEW":
      return {
        ...state,
        idNeedsReview: action.idNeedsReview
      };
    case "SET_PHONE_NUMBER_VERIFIED":
      return {
        ...state,
        phoneNumberVerified: action.verified
      };
    case "SET_NETWORKING_ERROR":
      return {
        ...state,
        networkingError: action.error
      };
    case "ADDRESS_VALID":
      return {
        ...state,
        addressValid: true
      };
    case "ADDRESS_INVALID":
      return {
        ...state,
        addressValid: false
      };
    case "SET_APPLICATION_PROGRESS":
      return {
        ...state,
        applicationProgress: action.payload
      };
    case "SET_LOGINS_REQUIRED":
      return {
        ...state,
        loginsRequired: action.payload
      };
    case "SET_FINICITY_LOGINS_REQUIRED":
      return {
        ...state,
        finicityLoginsRequired: action.payload
      };
    case "SET_AGGREGATOR_TYPE":
      return {
        ...state,
        aggregatorType: action.payload
      };
    default:
      return state;
  }
}
